import { create } from 'zustand';

/**
 * Weakness Store - Pure State Management
 * Rule: NO API IN STORE - Only state mutations
 * API calls are handled by WeaknessIntegration
 */
const useWeaknessStore = create((set) => ({
  // State
  weaknesses: [],
  categories: [],
  riskLevels: [],
  columnFilters: {},
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },
  loading: false,
  error: null,
  selectedWeakness: null,
  isEditing: false,
  isCreating: false,
  isDetailsOpen: false,
  lastUpdated: null,

  // Pure State Mutations - NO API CALLS
  setWeaknesses: (weaknesses) => set({
    weaknesses,
    lastUpdated: new Date().toISOString()
  }),

  setCategories: (categories) => set({ categories }),

  setRiskLevels: (riskLevels) => set({ riskLevels }),

  setPagination: (paginationData) => set({ paginationData }),

  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  setIsDetailsOpen: (isOpen) => set({ isDetailsOpen: isOpen }),

  clearError: () => set({ error: null }),

  // UI Actions
  startCreating: () => set({
    isCreating: true,
    isEditing: false,
    selectedWeakness: null
  }),

  startEditing: (weakness) => set({
    isEditing: true,
    isCreating: false,
    selectedWeakness: weakness
  }),

  cancelEditing: () => set({
    isEditing: false,
    isCreating: false,
    selectedWeakness: null
  }),

  setSelectedWeakness: (weakness) => set({
    selectedWeakness: weakness
  }),

  reset: () => set({
    weaknesses: [],
    categories: [],
    riskLevels: [],
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    loading: false,
    error: null,
    selectedWeakness: null,
    isEditing: false,
    isCreating: false,
    lastUpdated: null,
  }),
}));

export { useWeaknessStore };
